import script from "./NoCompanyPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./NoCompanyPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./NoCompanyPlaceholder.vue?vue&type=style&index=0&id=0e97b0f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e97b0f2"]])

export default __exports__